/* eslint-disable @typescript-eslint/no-empty-function */
import { CloseIcon } from 'assets/icons/CloseIcon'
import { DashboardCard, P } from 'styling/GlobalStyles'
import { IWidget } from 'types/dashboard.interface'
import { WidgetEditOverlay } from 'pages/Dashboard/Dashboard.styled'
import { WidgetHeader, WidgetTitle } from './widgetParts.styled'
import { WidgetBody } from '../hrLayout.styled'
import { HrWidgetBody } from './HrWidgetBody'

export const HrAISuggestionsWidget = ({ modalOpen, removeWidget, onDragOver, onDragStart, onDragDrop }: IWidget) => {
  return (
    <DashboardCard
      draggable={modalOpen}
      onDragStartCapture={() => onDragStart('suggestions', 1)}
      onDrop={onDragDrop}
      onDragEnd={(e) => e.preventDefault()}
      onDragOver={(e) => {
        e.preventDefault()
        onDragOver('suggestions')
      }}
      width='1fr'
      style={{ gridArea: 'suggestions', cursor: modalOpen ? 'grab' : 'normal' }}
    >
      {modalOpen && (
        <WidgetEditOverlay
          onClick={(e) => {
            removeWidget('suggestions')
            e.stopPropagation()
          }}
        >
          <P>Remove Widget</P>
          <CloseIcon />
        </WidgetEditOverlay>
      )}
      <WidgetHeader>
        <WidgetTitle>AI Suggestions</WidgetTitle>
      </WidgetHeader>
      <WidgetBody>
        <HrWidgetBody type='suggestions' />
      </WidgetBody>
    </DashboardCard>
  )
}
